import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Flex } from 'components/ui';
import {
    colors, space, fontSizes, fontWeights, lineHeights
} from 'style/config';

import mediaUtils from 'utils/Media';

const { Media } = mediaUtils;

const MAXIMIZED_FOOTER_HEIGHT = 60;

const CompareDrawerButtons = ({ onClearAll, onCompare, productCount, getText }) => {
    return (
        <>
            {/* Desktop: Header buttons */}
            <Media greaterThanOrEqual='md'>
                <Flex
                    alignItems='center'
                    gap={4}
                    css={styles.headerButtons}
                >
                    <Button
                        onClick={onClearAll}
                        data-at={Sephora.debug.dataAt('compare_drawer_clear_all')}
                        css={styles.clearAllButton}
                    >
                        {getText('clearAll')}
                    </Button>
                    <Button
                        variant='primary'
                        onClick={onCompare}
                        disabled={productCount < 2}
                        data-at={Sephora.debug.dataAt('compare_drawer_compare')}
                        css={styles.compareButtonHeader}
                    >
                        {getText('compare')}
                    </Button>
                </Flex>
            </Media>

            {/* Mobile & iPad: Footer buttons */}
            <Media lessThan='md'>
                <Flex
                    alignItems='center'
                    justifyContent='space-between'
                    css={styles.footer}
                >
                    <Button
                        onClick={onClearAll}
                        data-at={Sephora.debug.dataAt('compare_drawer_clear_all')}
                        css={styles.clearAllButtonFooter}
                    >
                        {getText('clearAll')}
                    </Button>
                    <Button
                        variant='primary'
                        onClick={onCompare}
                        disabled={productCount < 2}
                        data-at={Sephora.debug.dataAt('compare_drawer_compare')}
                        css={styles.compareButtonFooter}
                    >
                        {getText('compare')}
                    </Button>
                </Flex>
            </Media>
        </>
    );
};

CompareDrawerButtons.propTypes = {
    onClearAll: PropTypes.func.isRequired,
    onCompare: PropTypes.func.isRequired,
    productCount: PropTypes.number.isRequired,
    getText: PropTypes.func.isRequired
};

const styles = {
    // Desktop styles (header buttons)
    headerButtons: {
        alignItems: 'center',
        gap: space[4],
        justifyContent: 'flex-end',
        flexShrink: 0
    },
    compareButtonHeader: {
        whiteSpace: 'nowrap',
        minWidth: '265px',
        maxWidth: '268px'
    },
    clearAllButton: {
        color: colors.blue,
        fontSize: fontSizes.base,
        fontWeight: fontWeights.normal,
        padding: 0,
        minWidth: 'auto',
        border: 'none',
        background: 'none',
        boxShadow: 'none',
        textDecoration: 'none',
        whiteSpace: 'nowrap'
    },
    // Mobile/iPad styles (footer)
    footer: {
        position: 'absolute',
        bottom: 0,
        flexShrink: 0,
        gap: space[4],
        minHeight: `${MAXIMIZED_FOOTER_HEIGHT}px`,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${space[4]}px`,
        left: 0,
        right: 0,
        backgroundColor: colors.white,
        zIndex: 'calc(var(--layer-flyout) + 1)'
    },
    compareButtonFooter: {
        flex: 1,
        maxWidth: '268px',
        whiteSpace: 'nowrap',
        minWidth: '120px'
    },
    clearAllButtonFooter: {
        color: colors.blue,
        fontSize: fontSizes.base,
        fontWeight: fontWeights.normal,
        lineHeight: lineHeights.base,
        padding: 0,
        minWidth: 'auto',
        border: 'none',
        background: 'none',
        boxShadow: 'none',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        marginRight: `${space[4]}px`
    }
};

export default wrapFunctionalComponent(CompareDrawerButtons, 'CompareDrawerButtons');
